import {HttpErrorResponse, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth';
import {catchError, delay, switchMap} from 'rxjs/operators';
import {URLS} from '../utils/urls';
import {throwError} from 'rxjs';

let isRefreshing = false;
export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  // Inject the current `AuthService` and use it to get an authentication token:
  let authService = inject(AuthService);
  const authToken = inject(AuthService).getAuthToken();
  // Clone the request to add the authentication header.
  let newReq = req.clone();
  if(newReq.url in [URLS.LOGIN, URLS.REFRESH_TOKEN]) {

  } else{
    newReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken!}`,
      },
    });
  }
  // return next(newReq).pipe(
  //   delay(0)
  // );
  return next(newReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // 2️⃣ If NOT 401 → propagate
      if (error.status !== 401) {
        return throwError(() => error);
      }

      // 3️⃣ If already refreshing → logout
      if (isRefreshing) {
        authService.logout();
        return throwError(() => error);
      }

      isRefreshing = true;

      // 4️⃣ Try refresh token
      return authService.refreshAccessToken().pipe(
        switchMap((res) => {
          isRefreshing = false;

          authService.setAuthToken(res.accessToken);

          // Retry original request with new token
          return next(
            req.clone({
              setHeaders: {
                Authorization: `Bearer ${res.accessToken}`,
              },
            })
          );
        }),
        catchError(refreshError => {
          // 5️⃣ Refresh token also failed → logout
          isRefreshing = false;
          authService.logout();
          return throwError(() => refreshError);
        })
      );
    })
  );
}
